import { observer } from "mobx-react-lite"
import styles from "../styles/signup.module.scss"
import SignUpForm from "../components/organisms/SignUpForm"

const SignupPage = observer(function SignupPage() {
  return (
    <div className={styles.centeredContainer}>
      <SignUpForm />
    </div>
  )
})

export default SignupPage
